import React from 'react';
import PropTypes from 'prop-types';
import {LoadingOutlined} from '@ant-design/icons';
import {Spin} from 'antd';
import styles from './index.less';
import {useTranslation} from 'react-i18next';

const SyncLayer = () => {
  const {t} = useTranslation('common');

  return (
    <div className={styles.overlay}>
      <div className={styles.spinContainer}>
        <Spin indicator={<LoadingOutlined style={{fontSize: 32}} spin/>}  tip={t('synchronizing')}/>
      </div>
    </div>
  );
};

SyncLayer.propTypes = {
  synchronizing: PropTypes.bool,
};

export default SyncLayer;